import '/assets/styles/main.pcss';

import LazyLoad from 'vanilla-lazyload';
import Alpine from 'alpinejs';

import carousel from './components/carousel.js';

window.lazyloadInstance = new LazyLoad();
window.Alpine = Alpine;

Alpine.start();

carousel();
